import { State } from 'src/types'
import { edgeOfCommon } from '../edge'
import { hamidashiOfMiddleFingerBeltBackStyle } from '../hamidashi'
import { littleRingMergedFingerOfBeltBackStyle } from '../littleRingFinger'
import { thumbFingerOfBeltBackStyle } from '../thumbFinger'
import { beltTypeDrawer } from './beltTypeDrawer'

export const beltStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isBeltBackStyle =
    state?.baseModel?.backStyle === 'beltBackStyleCatcher' ||
    state?.backStyle?.value === 'beltBackStyleCatcher' ||
    state?.backStyle?.value === 'unselected'
  if (!isBeltBackStyle) return

  // 小指側の指袋
  littleRingMergedFingerOfBeltBackStyle(ctx, state?.middleLeftRingLittle?.color, state.stitch.color)

  // 親指側の指袋
  thumbFingerOfBeltBackStyle(ctx, state?.thumbIndexMiddleRight?.color, state.stitch.color)

  // ベルトスタイルのハミダシ
  hamidashiOfMiddleFingerBeltBackStyle(ctx, state.hamidashi)

  // ヘリ革
  edgeOfCommon(ctx, state.edge.color)

  // ベルトタイプ別の描画
  beltTypeDrawer(ctx, state)
}
